/* Biomiga RFQ only. Native Shopify contact POST; no fetch, recipient or backend. */
(() => {
  'use strict';
  const KEY = '__btsBiomigaRfqV1';
  if (window[KEY]) { window[KEY].check(); return; }
  const ids = ['bts-biomiga-rfq', 'bts-biomiga-rfq-dialog', 'bts-biomiga-rfq-form', 'bts-biomiga-rfq-response', 'bts-biomiga-rfq-variants'];
  let root, dialog, form, data, opener, oldOverflow, oldPadding, open = false, submitting = false, failed = false;
  const storageKey = () => 'bts-biomiga-rfq-pending:' + location.pathname;
  const byId = id => document.getElementById(id);
  const get = field => form.elements.namedItem('contact[' + field + ']');
  const set = (field, value) => { const el = get(field); if (el) el.value = value == null ? '' : String(value); };
  function duplicates() {
    const owned = root ? Array.from(root.querySelectorAll('[id]'), el => el.id) : [];
    return [...ids, ...owned].some(id => document.querySelectorAll('[id="' + CSS.escape(id) + '"]').length > 1);
  }
  function close() {
    if (!open) return;
    root.hidden = true; open = false;
    document.body.style.overflow = oldOverflow;
    document.body.style.paddingRight = oldPadding;
    if (opener && opener.isConnected) opener.focus();
  }
  function fail() {
    close(); failed = true;
    if (root) root.hidden = true;
    document.querySelectorAll('.js-biomiga-rfq[data-open-biomiga-rfq="true"]').forEach(el => { el.setAttribute('aria-disabled', 'true'); });
    console.warn('Biomiga RFQ unavailable: duplicate IDs or invalid configuration.');
  }
  function check() { if (duplicates()) fail(); }
  window[KEY] = { check };
  const focusable = () => Array.from(dialog.querySelectorAll('button,input,select,textarea,a[href],[tabindex="0"]')).filter(el => !el.disabled && !el.hidden && el.getClientRects().length && el.tabIndex >= 0);
  function syncVariant() {
    const value = get('Variant selection').value;
    const v = data.variants.find(v => String(v.id) === value);
    set('Variant ID', v ? v.id : ''); set('Variant title', v ? v.title : '');
    set('Seller SKU', v ? v.sku : ''); set('MPN', v ? v.mpn : '');
    const ctx = root.querySelector('[data-variant-context]');
    ctx.textContent = v ? v.title + ' · Seller SKU: ' + (v.sku || 'Not provided') + ' · MPN: ' + (v.mpn || 'Not provided') : value === 'help' ? 'Help me choose — no variant assumed.' : 'Select an offered variant or ask for help choosing. No variant assumed.';
  }
  function prefill() {
    const params = new URLSearchParams(location.search);
    let selected = '';
    if (params.has('variant')) {
      const values = params.getAll('variant');
      if (values.length === 1 && data.variants.some(v => String(v.id) === values[0])) selected = values[0];
    } else {
      // Only cart/add forms explicitly owned by this product. Unscoped page forms are ignored.
      const candidates = new Set(); let ambiguous = false;
      document.querySelectorAll('form[action*="/cart/add"][data-product-id]').forEach(f => {
        if (String(f.dataset.productId) !== String(data.productId)) return;
        const controls = Array.from(f.querySelectorAll('[name="id"]')).filter(el => !el.disabled && (!['radio','checkbox'].includes(el.type) || el.checked));
        controls.forEach(el => { if (data.variants.some(v => String(v.id) === el.value)) candidates.add(el.value); else ambiguous = true; });
      });
      if (!ambiguous && candidates.size === 1) selected = Array.from(candidates)[0];
    }
    get('Variant selection').value = selected;
    syncVariant();
    set('Page URL', location.origin + location.pathname + location.search);
  }
  function syncSupport() {
    const yes = ['Yes', 'Not sure'].includes(get('Research support requested').value);
    const branch = root.querySelector('[data-support-fields]');
    branch.hidden = !yes; branch.disabled = !yes;
    branch.querySelectorAll('input,select,textarea').forEach(el => { el.disabled = !yes; if (!yes) el.value = ''; });
  }
  function show(trigger, response = false) {
    check(); if (failed || !root || open) return;
    opener = trigger || document.activeElement;
    oldOverflow = document.body.style.overflow; oldPadding = document.body.style.paddingRight;
    const gap = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    if (gap) document.body.style.paddingRight = (parseFloat(getComputedStyle(document.body).paddingRight) + gap) + 'px';
    document.body.style.overflow = 'hidden'; root.hidden = false; open = true;
    if (!response) prefill();
    requestAnimationFrame(() => {
      const target = response ? byId('bts-biomiga-rfq-response') : dialog.querySelector('[data-initial-focus]');
      (target || focusable()[0] || dialog).focus();
    });
  }
  function init() {
    root = byId('bts-biomiga-rfq');
    if (!root) return;
    check(); if (failed) return;
    dialog = byId('bts-biomiga-rfq-dialog'); form = byId('bts-biomiga-rfq-form');
    try { data = JSON.parse(byId('bts-biomiga-rfq-variants').textContent); } catch (_) { fail(); return; }
    if (!dialog || !form || !data || !Array.isArray(data.variants) || !data.productId) { fail(); return; }
    if (data.variants.some(v => !v || !/^\d+$/.test(String(v.id)))) { fail(); return; }
    data.variants = data.variants.map(v => ({ ...v, title: String(v.title || ''), sku: typeof v.sku === 'string' ? v.sku : '', mpn: ['string','number'].includes(typeof v.mpn) ? String(v.mpn) : '' }));
    if (new Set(data.variants.map(v => String(v.id))).size !== data.variants.length) { fail(); return; }
    const select = get('Variant selection');
    data.variants.forEach(v => { const opt = document.createElement('option'); opt.value = String(v.id); opt.textContent = v.title + (v.available === false ? ' — availability to be confirmed' : ''); select.append(opt); });
    select.addEventListener('change', syncVariant);
    get('Research support requested').addEventListener('change', syncSupport);
    syncSupport(); syncVariant();
    const response = byId('bts-biomiga-rfq-response');
    // Shopify contact success can be shared by multiple forms on a page. An anchor alone never claims success.
    let pending = false;
    try { const t = Number(sessionStorage.getItem(storageKey())); pending = t > 0 && Date.now() - t < 2 * 60 * 60 * 1000; } catch (_) {}
    const ownReturn = location.hash === '#bts-biomiga-rfq-response' && pending;
    if (response.dataset.serverSuccess === 'true' && ownReturn) {
      response.querySelector('[data-success]').hidden = false;
      try { sessionStorage.removeItem(storageKey()); } catch (_) {}
      show(null, true);
    } else if (response.dataset.serverErrors === 'true' && ownReturn) { show(null, true); }
    document.addEventListener('click', e => {
      const trigger = e.target.closest('.js-biomiga-rfq[data-open-biomiga-rfq="true"]');
      if (trigger) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); show(trigger); return; }
      if (open && (e.target === root || e.target.closest('[data-close-biomiga-rfq]'))) close();
    }, true); // Capture only the uniquely marked Biomiga trigger before theme/PageFly handlers.
    document.addEventListener('keydown', e => {
      if (!open) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key === 'Tab') {
        const items = focusable(), first = items[0], last = items[items.length - 1];
        if (!first) { e.preventDefault(); dialog.focus(); return; }
        if (e.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) { e.preventDefault(); first.focus(); }
      }
    });
    document.addEventListener('focusin', e => { if (open && !dialog.contains(e.target)) (focusable()[0] || dialog).focus(); });
    form.addEventListener('submit', e => {
      check();
      if (failed || submitting) { e.preventDefault(); return; }
      syncSupport(); syncVariant();
      if (!form.checkValidity()) { e.preventDefault(); form.reportValidity(); return; }
      // Do not prevent a valid native POST or interfere with Shopify CAPTCHA listeners.
      // Submit controls have no names; defer disabling until initial serialization/hooks finish.
      submitting = true;
      try { sessionStorage.setItem(storageKey(), String(Date.now())); } catch (_) {}
      setTimeout(() => {
        // A local harness / Shopify hook may have canceled submission; leave retry available.
        if (e.defaultPrevented) { submitting = false; return; }
        form.querySelectorAll('[type="submit"]').forEach(el => { el.disabled = true; el.textContent = 'Submitting…'; });
      }, 0);
    });
    window.addEventListener('pageshow', () => { submitting = false; form.querySelectorAll('[type="submit"]').forEach(el => { el.disabled = false; el.textContent = 'Request a quote'; }); });
    new MutationObserver(check).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
})();
